import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import { ProfileUserEntity } from 'services/openapi';
import { getAuthenticatedProfile } from 'utils/helpers';

import { UserServiceQueryKeys } from '../constants';

export const useGetUserProfileQuery = () => {
  const queryKey = [UserServiceQueryKeys.GET_USER_PROFILE];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<ProfileUserEntity, Error>({
    queryKey,
    queryFn: getAuthenticatedProfile,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...QUERY_CACHE_CONFIG.UNTIL_INVALIDATED,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
